(function ($) {

    $(document).ready(function () {
        if ($(".faq-accordian").length > 0) {
            $('.faq-accordian .column-wrapper .accordian h4').on('click', function () {
                $(this).toggleClass('rotate');
                $(this).parent().find('.content-wrap').slideToggle();
            });
            $('.faq-accordian .column-wrapper .accordian').each(function () {
                if ($(this).find('.content-wrap p').length > 1) {
                    $(this).find('.content-wrap > span').css({'display': 'block'});
                }
            });

            $('.faq-accordian .column-wrapper .accordian .content-wrap > span').on('click', function () {

                var txt = $(this).text();
                if (txt === 'Read More') {
                    $(this).text('Read Less');
                    $('.faq-accordian .column-wrapper .accordian .content-wrap .hidden-content').slideDown();
                }
                else {
                    $(this).text('Read More');
                    $('.faq-accordian .column-wrapper .accordian .content-wrap .hidden-content').slideUp();
                }
            });

        }
    });

})(jQuery);